import {usePageContext} from '~/components'
import {calculateDeltaPercentage} from '@eitje/web_components/src/components/graph/helpers'
import {Colors} from '@eitje/assets'

const {mediumGreen, mediumRed} = Colors

export const useAggregatesTaxonomy = () => {
	const {selectedSeriesPointIndex, graphVariantsTaxonomy, graphs: graphSeries} = usePageContext()

	const getSelectedSeriesValue = seriesValues => seriesValues[selectedSeriesPointIndex]

	return graphVariantsTaxonomy.map(aggregate => {
		const seriesPoints = graphSeries.find(series => series.name === aggregate.name).data
		const actual = seriesPoints[selectedSeriesPointIndex]?.y
		const comparison = seriesPoints[selectedSeriesPointIndex - 1]?.y

		return {
			...aggregate,
			// We don't aggregate the series points here; we select the active series value.
			aggregateFn: getSelectedSeriesValue,
			formatFn: aggregate.compactFormatFn || aggregate.fullFormatFn,
			delta: {
				value: calculateDeltaPercentage({actual, comparison}),
				positive: mediumGreen,
				negative: mediumRed,
			},
		}
	})
}
